import { render } from "./Answer1.vue?vue&type=template&id=e233285a&bindings={\"next\":\"options\"}"
import script from "./Answer1.vue?vue&type=script&lang=js"
export * from "./Answer1.vue?vue&type=script&lang=js"

import "./Answer1.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script